import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from '../../../state/action-sources';
import { InventoryItemDefinition, InventoryState } from '../../job-inventory/job-inventory.state';

export type YemboCallState = 'yemboStartOnsite' | 'yemboSelfSurvey';

export const JobCreateInventoryActions = createActionGroup({
	source: ActionSource.CREATE_INVENTORY,
	events: {
    'Header Clicked': emptyProps(),
		'Add Room Button Clicked': emptyProps(),
		'Yembo Option Checkbox Clicked': props<{ option: InventoryState['yemboOptions'][number] }>(),
		'Room Autocomplete Input Changed': props<{ value: string }>(),
		'Room Autocomplete Search Fired': props<{ query: string }>(),
    'Room Selected': props<{ roomId: string; name: string }>(),
    'Remove Room Button Clicked': props<{ roomId: string }>(),
		'Item Quantity Input Changed': props<{
			itemId: string;
			roomId: string;
			quantity: number;
		}>(),
		'Remove Item Button Clicked': props<{
			roomId: string;
			itemId: string;
		}>(),
		'Item Autocomplete Search Fired': props<{
			query: string;
		}>(),
		'Item Autocomplete Item Selected': props<{
			item: InventoryItemDefinition;
			roomId: string;
		}>(),
		'Item Autocomplete Input Changed': props<{
			roomId: string;
			value: string;
		}>(),

	},
});
